import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  color: ${({color}) => color};
  font-weight: 600;
`;

export default Container;
